import { DsFormInstanceEditInterface } from '../interfaces/form-instance/ds-form-instance-edit.interface';
import { DsFormInstanceSchemaInterface } from '../interfaces/form-instance/ds-form-instance-schema.interface';
import { DsFormInstanceSchema } from './ds-form-instance-schema';

export class DsFormInstanceEdit {
  /**
   * Instance ID
   */
  public id: number;

  /**
   * Instance name
   */
  public name: string;

  /**
   * Instance template ID
   */
  public template_id: number;

  /**
   * Instance status
   */
  public status: number;

  /**
   * Instance schema ID
   */
  public schema: DsFormInstanceSchemaInterface;

  /**
   * Creates an instance of DsFormInstance.
   *
   * @param json the json data
   */
  constructor(json: DsFormInstanceEditInterface) {
    this.id = json.id;
    this.name = json.name;
    this.template_id = json.formTemplateId;
    this.status = json.status;
    this.schema = new DsFormInstanceSchema(json.schema);
  }
}
